import Image from "next/image";

/** Bump when the files in /public/background-images are replaced, so browsers and the CDN refetch them. */
export const BG_VERSION = "v=3";

/**
 * Full-bleed page-hero background: the image plus overlays that keep text readable
 * and fade it into the page below.
 */
export function HeroBackground({
  src,
  position = "center",
  opacity = 0.6,
}: {
  /** File name inside /public/background-images, e.g. "workflow.webp" */
  src: string;
  position?: string;
  opacity?: number;
}) {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 z-0">
      <Image
        src={`/background-images/${src}?${BG_VERSION}`}
        alt=""
        fill
        priority
        sizes="100vw"
        className="object-cover"
        style={{ objectPosition: position, opacity }}
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(10,10,15,0.7) 0%, rgba(10,10,15,0.25) 30%, rgba(10,10,15,0.35) 65%, #0A0A0F 100%)",
        }}
      />
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(ellipse 80% 70% at 50% 45%, transparent 35%, rgba(10,10,15,0.6) 100%)" }}
      />
    </div>
  );
}

/**
 * Soft bottom fade into the page background. Sits above the image, glows and orbs
 * (which the hero's overflow-hidden would otherwise clip into a hard line) but
 * below the hero content (z-10).
 */
export function HeroFade({ className = "" }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-x-0 bottom-0 z-[5] h-40 sm:h-56 lg:h-72 ${className}`}
      style={{
        background:
          "linear-gradient(180deg, rgba(10,10,15,0) 0%, rgba(10,10,15,0.18) 25%, rgba(10,10,15,0.5) 50%, rgba(10,10,15,0.82) 75%, #0A0A0F 100%)",
      }}
    />
  );
}
